export const isValueOrZero = (v) => v === 0 || !!v;
export const isValueFalseOrZero = (v) => v === 0 || v === false || !!v;
export const isEmpty = (v) => v === null || v === undefined || v === '';